import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ServiceSchema, BreadcrumbSchema } from '@/components/seo/SchemaMarkup';

const EmergencyDentist = () => {
  // FAQ Schema for Voice Search - Emergency Dental Questions
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Where can I find an emergency dentist near me in Fort Worth?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Fort Worth Dental offers same-day emergency appointments at our office at 4620 Citylake Blvd W, Fort Worth, TX 76132. Call (817) 985-3337 for immediate assistance with dental emergencies including severe toothaches, broken teeth, and knocked-out teeth."
        }
      },
      {
        "@type": "Question",
        "name": "How much does an emergency dental visit cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Fort Worth Dental offers a $99 emergency exam and x-ray special. Additional treatment costs vary depending on the nature of the emergency. We accept most dental insurance and offer financing options."
        }
      },
      {
        "@type": "Question",
        "name": "What should I do if I knock out a tooth?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "If you knock out a permanent tooth: 1) Pick it up by the crown (not the root), 2) Rinse gently with water if dirty, 3) Try to place it back in the socket, or keep it moist in milk, 4) Call Fort Worth Dental immediately at (817) 985-3337. Time is critical - teeth can often be saved if treated within 1 hour."
        }
      },
      {
        "@type": "Question",
        "name": "Is a severe toothache a dental emergency?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, severe tooth pain that doesn't respond to over-the-counter pain relievers is considered a dental emergency. It could indicate an infection, abscess, or other serious condition that requires immediate treatment. Call Fort Worth Dental for same-day emergency care."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer same-day emergency dental appointments?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Fort Worth Dental offers same-day emergency dental appointments. We understand dental emergencies can't wait. Call us at (817) 985-3337 and we'll do our best to see you the same day for emergency treatment."
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white py-16">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Emergency Dentist Fort Worth TX | Same-Day Appointments | $99 Exam</title>
        <meta name="description" content="Emergency dental care in Fort Worth TX. Same-day appointments available. $99 emergency exam and x-ray. Toothache, broken tooth, dental pain relief. Call (817) 985-3337." />
        <meta name="keywords" content="emergency dentist fort worth, dental emergency fort worth tx, same day dentist, toothache relief, broken tooth repair, emergency dental care, emergency dentist near me, 24 hour dentist fort worth" />
        <link rel="canonical" href="https://fortworthdental.com/emergency-dentist" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      
      {/* Schema.org Structured Data */}
      <ServiceSchema 
        serviceName="Emergency Dental Care"
        description="Same-day emergency dental appointments in Fort Worth TX. Fast relief for toothaches, broken teeth, and dental emergencies."
        url="https://fortworthdental.com/emergency-dentist"
      />
      <BreadcrumbSchema items={[
        { name: "Home", url: "https://fortworthdental.com/" },
        { name: "Emergency Dentist", url: "https://fortworthdental.com/emergency-dentist" }
      ]} />
      
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold text-gray-800 mb-8">Emergency Dentist Services</h1>
          <p className="text-xl text-gray-600 mb-12">Fast, professional care when you need it most</p>
          
          <div className="bg-red-50 border-l-4 border-red-600 p-6 mb-8">
            <h2 className="text-2xl font-bold text-red-800 mb-2">Dental Emergency?</h2>
            <p className="text-red-700 mb-4">Call us immediately for same-day appointments</p>
            <a href="tel:8179853337" className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-red-700 inline-block">
              Call Now: (817) 985-3337
            </a>
          </div>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">$99 Emergency Exam and X-Ray</h2>
            <p className="text-gray-700 leading-relaxed">
              We understand dental emergencies can happen at any time. Our experienced team is ready to provide fast, 
              effective treatment to relieve your pain and address your dental emergency.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default EmergencyDentist;
